<template>
    <div id="errors" class="form__item form__error" v-if="errors">
       <template v-for="key in errors">
            <template  v-for="massage in key">
                <span class="form__error-text" v-html="massage"></span>
            </template>
       </template>
    </div>
</template>

<script>
    export default {
        name: "errors",
        data: () => ({
        }),
        props: ['errors'],
        watch: {
            errors() {
                if (this.errors) {
                    setTimeout(function() {
                        document.getElementById("errors").scrollIntoView({block: "center", behavior: "smooth"});
                    }, 500);
                }
            }
        }
    }
</script>

<style scoped>

</style>
